import { client } from "./client";

const ROUTES = {
  getDocument: docId => `/documents/${docId}/`,
  getTextTagging: (docId, offset, limit) => `/get_text_tagging/${docId}/${offset}/${limit}/`,
  patchDocument: docId => `/documents/${docId}/`,
  saveRotation: () => `/save_rotation/`,
  continueFlow: () => `/continue_flow/`,
  listDocuments: ({ limit, offset, statesFilter, id, company_id, filters, kind, sort }) => {
    const base = 'documents/?dummy=0';
    const companyParam = company_id ? `&company_id=${company_id}` : '';
    const kindParam = kind ? `&kind=${kind}` : '';
    const idParam = id ? `&id=${id}` : '';
    const limitParam = limit ? `&limit=${limit}` : '';
    const offsetParam = offset ? `&offset=${offset}` : '';
    const stateParam = statesFilter ? `&state__in=${statesFilter}` : '';
    const filtersParam = filters || '';
    const orderingParam = sort ? `&ordering=${sort}` : '';
  
    return `${base}${companyParam}${kindParam}${idParam}${limitParam}${offsetParam}${stateParam}${filtersParam}${orderingParam}`;
  },    
  listDeletedDocuments: ({ limit, offset, statesFilter, id, company_id, filters, kind, sort }) => {
    const base = 'deleted_documents/?dummy=0';
    const companyParam = company_id ? `&company_id=${company_id}` : '';
    const kindParam = kind ? `&kind=${kind}` : '';
    const idParam = id ? `&id=${id}` : '';
    const limitParam = limit ? `&limit=${limit}` : '';
    const offsetParam = offset ? `&offset=${offset}` : '';
    const stateParam = statesFilter ? `&state__in=${statesFilter}` : '';
    const filtersParam = filters || '';
    const orderingParam = sort ? `&ordering=${sort}` : '';
  
    return `${base}${companyParam}${kindParam}${idParam}${limitParam}${offsetParam}${stateParam}${filtersParam}${orderingParam}`;
  },      
  // listDocuments: () => `documents/`,
  // getDocumentStates: () => `get_document_states/`,
  getDocumentStates: ({ companydb_id, filters }) => `get_document_states/?companydb_id=${companydb_id}${filters}`,
  getRetryDetectionStates: () => 'get_retry_detection_states/', 
  updateAccountMoves: () => `update_account_moves/`,
  multiContinueFlow: () => `multi_continue_flow/`,
  multiRetryAll: () => `multi_retry_all/`,
  createDocumentBatch: () => `/document_batch/`,
  urlCreateInvoiceLine: () => 'create_invoice_line/',
  urlDeleteInvoiceLine: () => 'delete_invoice_line/'
};

let listDocumentsBase = ({page, itemsPerPage, filters, currentCompanyId, statesFilter, documentsListId, kind, sortField, sortOrder}, route = ROUTES.listDocuments) => {
    let qs = {company_id: currentCompanyId, };
    if (itemsPerPage) {
      let offset = (page - 1) * itemsPerPage;
      qs = { ...qs, limit: itemsPerPage, offset, }
    }
    if (statesFilter) {
      qs = { ...qs, statesFilter, }
    }
    if (documentsListId) {
      qs = { ...qs, id: documentsListId, }
    } 
    if (filters) {
      qs = { ...qs, filters, }
    }
    if (kind) {
      qs = { ...qs, kind, }
    }
    if (sortField) {
      const orderMapping = {
        state_display: 'state',
        kind_display: 'supplierdb',
      }
      const mappedSortField = orderMapping[sortField] || sortField;
      qs = {...qs, sort: `${sortOrder ? '-' : ''}${mappedSortField}`};
    }
    // return documents.rec_get(qs,count)
    let url = route({ ...qs });
    return client.get(url);
  }

let get_text_tagging = (id,offset,limit) => {
  return new Promise((resolve, reject)=> {
    let text_tagging = []
    client.get(ROUTES.getTextTagging(id,offset,limit)).then(resp => {
      for( let i in resp.data.text_tagging){
        let tagging = resp.data.text_tagging[i]
        while(tagging.page>=text_tagging.length){
          text_tagging.push([])
        }
        if(!tagging.label){
          tagging.label={'human':'background','human_payroll':'background'}
        }
        text_tagging[tagging.page].push(tagging)
      }  
      if(offset+limit>resp.data.count){
        resolve(text_tagging)
      }
      else{
        get_text_tagging(id,offset+limit,limit).then(resp => {
          for( let i in resp){
            let page = resp[i]
            while(i>=text_tagging.length){
              text_tagging.push([])
            }
            text_tagging[i] = text_tagging[i].concat(page)
          }  
          resolve(text_tagging)
        })
      }
    }).catch(err=>reject(err))
  })
}

let set_text_tagging_format = (text_tagging_pages) => {
  let text_tagging = []
  for( let i in text_tagging_pages){
    let page = text_tagging_pages[i]
    for( let j in page){
      let tagging = page[j]
      text_tagging.push(tagging)
    }
  }
  return text_tagging
}

export const apiDocuments = {
  get_text_tagging: get_text_tagging,
  getDocument: ({ id }) => {
    return new Promise((resolve, reject)=> {
      client.get(ROUTES.getDocument(id)).then(resp => {
        resolve(resp)
        // let offset = 0;
        // let limit = 5000;
        // get_text_tagging(id,offset,limit).then(text_tagging => {
        //   resp.data.text_tagging = text_tagging
        //   resolve(resp)
        // }).catch(err=>{
        //   reject(err)
        // })
        
      }).catch(err=>{
        reject(err)
      })
    })
    
  },
  patchDocument: ({
    id,
    text_tagging,
    state,
    companydb,
    supplierdb,
    customerdb,
    comment,
    tags,
    kind,
    metadata,
    forced_move,
    actividad,
    project,
    channel,
    section,
    delegation,
    department,
    inversion_sujeto_pasivo_igic,
    inversion_sujeto_pasivo_iva,
    inversion_sujeto_pasivo_igic_percent,
    inversion_sujeto_pasivo_iva_percent,
    intracomunitario,
    intracomunitario_percent,
    intracomunitario_type,
    foreign_entity,
    foreign_entity_type,
    extracomunitario,
    extracomunitario_type,
    no_sujeta,
    bien_inversion,
    rebu,
    rebu_precio_compra,
    written_description,
    description,
    importaciones_percent,
    iva_igic_no_deducible,
    comerciante_minorista,
    gasto_iva_parcial,
    iva_parcial,
    gasto_iva_percent,
    accounting_date_config,
    default_accounting_date,
    registro_date_config,
    default_registro_date,
    punteado,
    prorate,
    building_code,
    apply_modelo,
    apply_415,
    serie,
    doc_number,
    doc_number_prefix,
    retention_type_name,
    notes,
    currency,
    expens_income_type,
  }) => {
    return new Promise((resolve, reject)=> {
      if(project == undefined)
        project = null;
      if (channel == undefined)
        channel = null;
      if (section == undefined)
        section = null;
      if (delegation == undefined)
        delegation = null;
      if (department == undefined)
        department = null;
      if (expens_income_type == undefined)
        expens_income_type = null;
      if(supplierdb == undefined)
        supplierdb = null;
      if(customerdb == undefined)
        customerdb = null;

      if(text_tagging){
        text_tagging = set_text_tagging_format(text_tagging)
      }

      if(notes == undefined) {
        notes = '';
      }
      client.patch(ROUTES.patchDocument(id), {
        text_tagging,
        state,
        companydb,
        supplierdb,
        customerdb,
        comment,
        tags,
        kind,
        metadata,
        currency,
        forced_move,
        actividad,
        project,
        channel,
        section,
        delegation,
        department,
        inversion_sujeto_pasivo_igic,
        inversion_sujeto_pasivo_iva,
        inversion_sujeto_pasivo_igic_percent,
        inversion_sujeto_pasivo_iva_percent,
        intracomunitario,
        intracomunitario_percent,
        intracomunitario_type,
        extracomunitario,
        extracomunitario_type,
        no_sujeta,
        bien_inversion,
        rebu,
        rebu_precio_compra,
        written_description,
        description,
        importaciones_percent,
        iva_igic_no_deducible,
        comerciante_minorista,
        gasto_iva_parcial,
        iva_parcial,
        gasto_iva_percent,
        accounting_date_config,
        default_accounting_date,
        registro_date_config,
        default_registro_date,
        punteado,
        prorate,
        building_code,
        apply_modelo,
        apply_415,
        serie,
        doc_number,
        doc_number_prefix,
        retention_type_name,
        notes,
        expens_income_type,
      }).then(resp => {
        let offset = 0;
        let limit = 5000;
        get_text_tagging(id,offset,limit).then(text_tagging => {
          resp.data.text_tagging = text_tagging
          resolve(resp)
        }).catch(err=>{
          reject(err)
        })
      }).catch(err=>{
        reject(err)
      })
    })
  },
  saveRotation: ({ id, globalRotation, rotationPerDocument}) => {
    return client.post(
      ROUTES.saveRotation(),
      { id, globalRotation, rotationPerDocument }
    );
  },
  continueFlow: ({
    id,
    id_document,
    text_tagging,
    metadata,
    supplierdb,
    customerdb,
    accountMoves,
    manually_fixed,
    kind,
    cancel_edit,
    dirty,
    actividad,
    project,
    channel,
    section,
    delegation,
    department,
    expens_income_type,
    inversion_sujeto_pasivo_igic,
    inversion_sujeto_pasivo_iva,
    inversion_sujeto_pasivo_igic_percent,
    inversion_sujeto_pasivo_iva_percent,
    intracomunitario,
    intracomunitario_percent,
    intracomunitario_type,
    foreign_entity,
    foreign_entity_type,
    extracomunitario,
    extracomunitario_type,
    no_sujeta,
    bien_inversion,
    rebu,
    rebu_precio_compra,
    written_description,
    description,
    importaciones_percent,
    iva_igic_no_deducible,
    comerciante_minorista,
    gasto_iva_parcial,
    iva_parcial,
    gasto_iva_percent,
    accounting_date_config,
    default_accounting_date,
    registro_date_config,
    default_registro_date,
    punteado,
    prorate,
    actividad_str,
    building_code,
    apply_modelo,
    apply_415,
    serie,
    doc_number,
    doc_number_prefix,
    retention_type_name,
    criterio_de_caja,
    is_comerciante_minorista,
    inv_number_to_rectify,
    inv_date_to_rectify,
    is_comerciante_minorista_percent,
    description_sii,
    written_description_sii,
    continue_flow_doc,
    payment_account,
    charge_account,
    notes,
    currency,
    fiscal_location,
    paid,
    is_cartera_active,
    payment_method_id,
    cartera,
    cartera_account,
  }) => {
    if(supplierdb==undefined)
      supplierdb=null
    if(customerdb==undefined)
      customerdb=null
    if(text_tagging){
      text_tagging = set_text_tagging_format(text_tagging).slice(0, 3000)
    }
    return client.post(ROUTES.continueFlow(), {
      id,
      id_document,
      text_tagging,
      metadata,
      supplierdb,customerdb,
      accountMoves,
      manually_fixed,
      kind,cancel_edit,
      dirty,
      actividad,
      project,
      channel,
      section,
      delegation,
      department,
      expens_income_type,
      inversion_sujeto_pasivo_igic,
      inversion_sujeto_pasivo_iva,
      inversion_sujeto_pasivo_igic_percent,
      inversion_sujeto_pasivo_iva_percent,
      intracomunitario,
      intracomunitario_percent,
      intracomunitario_type,
      foreign_entity,
      foreign_entity_type,
      extracomunitario,
      extracomunitario_type,
      no_sujeta,
      bien_inversion,
      rebu,
      rebu_precio_compra,
      written_description,
      description,
      importaciones_percent,
      iva_igic_no_deducible,
      comerciante_minorista,
      gasto_iva_parcial,
      iva_parcial,
      gasto_iva_percent,
      accounting_date_config,
      default_accounting_date,
      registro_date_config,
      default_registro_date,
      punteado,
      prorate,
      actividad_str,
      building_code,
      apply_modelo,
      apply_415,
      serie,
      doc_number,
      doc_number_prefix,
      retention_type_name,
      criterio_de_caja,
      is_comerciante_minorista,
      inv_number_to_rectify,
      inv_date_to_rectify,
      is_comerciante_minorista_percent,
      description_sii,
      written_description_sii,
      continue_flow_doc,
      payment_account,
      charge_account,
      notes,
      currency,
      fiscal_location,
      paid,
      is_cartera_active,
      payment_method_id,
      cartera,
      cartera_account,
     });
  },
  // rec_get:(qs,count) =>{
  //   let p = new Promise((resolve,reject)=>{
  //     if(Object.keys(qs).includes('limit') && qs.limit>100 && count > qs.offset+100){
  //       let qs2 = { ...qs, limit: 100}
  //       client.get(ROUTES.listDocuments({ ...qs2 })).then(res=>{
  //         let qs3 = { ...qs, offset: qs.offset+100, limit: qs.limit - 100, }
  //         count= res.data.count
  //         documents.rec_get(qs3).then((res2)=>{
  //           res.data.results = res.data.results.concat(res2.data.results)
  //           resolve(res)
  //         }).catch(e=>{
  //           reject(e)
  //       });
  //       }).catch(e=>{
  //         reject(e)
  //       });
  //     }
  //     else{
  //       client.get(ROUTES.listDocuments({ ...qs })).then(res=>{
  //         resolve(res)
  //       }).catch(e=>{
  //         reject(e)
  //       });
  //     }
  //   })
  //   return p
    
  // },
  listDocuments: (qs) => {
    return listDocumentsBase(qs)
  },
  getDocumentStates: ({ currentCompanyId, filts }) => {
    let qs = {companydb_id: currentCompanyId, filters: filts};
    let url = ROUTES.getDocumentStates({ ...qs });
    let params = { params: { ...qs } };
    return client.get(url, { params });
  },
  getRetryDetectionStates: () => {
    let url = ROUTES.getRetryDetectionStates();
    return client.get(url)
  },

  updateAccountMoves: ({ accountMoves }) => {
    let qs = {account_moves: accountMoves, };
    let url = ROUTES.updateAccountMoves({ ...qs });
    let params = { params: { ...qs } };
    return client.post(url, { params });
  },
  multiContinueFlow: (params) => {
    let url = ROUTES.multiContinueFlow();
    return client.post(url, params);
  },
  multiRetryAll: (ids) => {
    let url = ROUTES.multiRetryAll(ids);
    return client.post(url, ids);
  },
  createDocumentBatch: (companyDBId, userId, files, upload_config = null) => {
    let url = ROUTES.createDocumentBatch();
    const formData = new FormData();
    formData.append('company_db', companyDBId);
    formData.append('user', userId);
    formData.append('files', files);
    if (upload_config) {
      formData.append('upload_config', upload_config);
    }
    return client.post(url, formData);
  },
  listDeletedDocuments: (qs) =>{
    return listDocumentsBase(qs,ROUTES.listDeletedDocuments)
  },
  createInvoiceLine(data){
    const formData = new FormData();
    let url = ROUTES.urlCreateInvoiceLine();
    formData.append('invoice_line_id',data.invoice_line_id); 
    formData.append('document_id',data.document_id); 
    formData.append('total_cost',data.total_cost);
    formData.append('gross_amount',data.gross_amount);
    formData.append('unit_price_without_tax',data.unit_price_without_tax);
    formData.append('quantity', data.quantity);
    formData.append('description', data.description);
    formData.append('TaxesOutputs',data.TaxesOutputs);
    formData.append('metadata' , JSON.stringify(data.metadata));
    return client.post(url,formData);
  },
  updateInvoiceLine(url){
    const formData = new FormData();
    formData.append('datos','datos') 
    return client.post(url,formData);
  },
  deleteInvoiceLine(data){
    const formData = new FormData();
    let url = ROUTES.urlDeleteInvoiceLine();
    formData.append('document_id',data.document_id);
    formData.append('invoice_line_id',data.invoice_line_id); 
    return client.post(url,formData);
  },
  
};
